import React, { Component } from 'react';

import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { Button } from 'react-bootstrap';

import { toggleCollapsedNav } from '../../redux/action/Theme';

import logoSm from '../../assets/img/Logo-th.png';
// import logoSm from '../../assets/img/EEC-logo.png';
// import logo from '../../assets/img/EEC-text.png';

class SidebarHeader extends Component {

    toggleSidebar = () => {
        const { navCollapsed, toggleCollapsedNav } = this.props;
        toggleCollapsedNav(!navCollapsed);
        
        document.getElementById('tggl-btn').blur();
    }

    render = () => {
        return (
            <>
                <div className="menu-header" style={{ height: '100px'}}>
                    <span>
                        <Link className="navbar-brand" to="/apps/dashboard">
                            <img className="brand-img img-fluid" src={logoSm} alt="EEC Brand Logo" style={{ height: '90px', marginRight: '8px' }} />
                            {/* <img className="brand-img img-fluid" src={logo} alt="EEC Brand Logo" style={{ height: '50px' }} /> */}
                        </Link>
                        {/* <Button
                            id="tggl-btn"
                            variant="flush-secondary"
                            onClick={() => this.toggleSidebar()}
                            className="btn-icon btn-rounded flush-soft-hover navbar-toggle"
                        >
                            <span className="icon">
                                <span className="icon">
                                    <i className="fa-classic fa-solid fa-arrow-left-to-line fa-fw"></i>
                                </span>
                            </span>
                        </Button> */}
                    </span>
                </div>
            </>
        )
    }

}

const mapStateToProps = ({ theme }) => {
    const { navCollapsed } = theme;
    return { navCollapsed };
}

export default connect(mapStateToProps, { toggleCollapsedNav} )(SidebarHeader);